export function SearchAndPinListTranslator(title, url, icon, is_bookmarked, i18nData) {
  function deepSearch(sKey, oKeys, obj) {
    if (typeof obj[sKey] === 'undefined') return
    if (!oKeys.length) return obj[sKey]
    return deepSearch(oKeys.pop(), oKeys, obj[sKey])
  }

  const result = []
  for (const lang in i18nData) {
    const keys = title.split('.')
    result.push({ title: deepSearch(keys.reverse().pop(), keys, i18nData[lang]), url, icon, is_bookmarked })
  }

  return result
}

export function QuerySerialize(obj, prefix) {
  const str = []
  let p = null
  for (p in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(p)) {
      const k = prefix ? `${prefix}[${p}]` : p,
        v = obj[p]
      str.push(
        v !== null && typeof v === 'object'
          ? QuerySerialize(v, k)
          : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
      )
    }
  }
  return str.join('&')
}

export function TranslateNumbers(input) {
  const array = input.split('')
  const persian = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
  const english = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]

  array.map(function(value, i, array) {
    if (persian.indexOf(array[i]) >= 0) {
      array[i] = english[persian.indexOf(array[i])]
    }
  })
  return array.join('')
}
